<template>
  <div>
    <TextAreaInput maxlength="25" :value="nameValue" @input="emitInputValut($event)" :showTitle="false" placeholder="عنوان متن ثابت را اینجا وارد نمائید" required />
  </div>
</template>

<script>
import TextAreaInput from '@/components/common/form/formModules/TextAreaInput.vue'
export default {
  components: {
    TextAreaInput,
  },
  props: {
    nameValue: {
      default: null,
    },
  },
  methods: {
    emitInputValut(payload) {
      this.$emit('textAreaInputChange', payload)
    },
  },
}
</script>

<style></style>
